import React from "react";
const SvgPublish = props => (
  <svg viewBox="0 0 40 40" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#39434e"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path d="M28.837 20.732v7.666a1.917 1.917 0 01-1.916 1.917H11.588a1.917 1.917 0 01-1.917-1.917V13.065c0-1.058.859-1.917 1.917-1.917h7.666" />
      <path d="M21.34 22.3h-3.833v-3.833l9.695-9.515a.957.957 0 011.355 0l2.478 2.477a.958.958 0 010 1.356L21.34 22.3zm3.863-11.35l3.833 3.833" />
    </g>
  </svg>
);
export default SvgPublish;
